/* eslint-disable jsx-a11y/anchor-is-valid */
import styles from 'styles/components/header.module.scss';
import Logo from './logo';
import { EditOutlined, LogoutOutlined, SwapOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Tooltip } from 'antd';
import { logout } from 'services/api/users';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import ProfileContext from 'services/profileContext';
import EditWorkspaceInfoModal from './editWorkspaceInfoModal';
import { isAdmin, useWindowSize } from 'utils/utils';

const Header = ({ width = 1034 }) => {
  const navigate = useNavigate();
  const { profile, clearProfile } = useContext(ProfileContext);
  const [isEditWorkspaceInfoModalOpen, setIsEditWorkspaceInfoModalOpen] =
    useState(false);

  const { width: widthWindow } = useWindowSize();
  const isMobile = widthWindow < 760;

  const onMenuClick = (e) => {
    logout(() => {
      navigate('/login');
      clearProfile();
    });
  };

  const items = [
    {
      key: '1',
      label: (
        <span>
          <LogoutOutlined />
          &nbsp;Logout
        </span>
      ),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner} style={{ width }}>
        <div className={styles.left}>
          <a
            href={isAdmin(profile) ? '/#/cycles' : '/#/my/cycles'}
            style={{ textDecoration: 'none' }}
          >
            <Logo />
          </a>
          <div className={styles.workspace}>
            <Tooltip title="Workspace name" placement="bottom">
              {/* <div className={styles.workspaceLabel}>Workspace</div> */}
              <div className={styles.workspaceName}>
                {profile?.workspace?.name}&nbsp;
                {isAdmin(profile) && (
                  <Button
                    type="link"
                    style={{ padding: 0, height: 'auto', fontSize: 12 }}
                    onClick={() => {
                      setIsEditWorkspaceInfoModalOpen(true);
                    }}
                  >
                    <EditOutlined />
                  </Button>
                )}
              </div>
            </Tooltip>
          </div>
        </div>
        <div className={styles.right}>
          {isAdmin(profile) && (
            <div className={styles.roleSelector}>
              {window.location.hash.startsWith('#/my/') ? (
                <Button type="link" onClick={() => navigate('/cycles')} icon={<SwapOutlined />}>
                  {isMobile ? 'Admin' : 'Switch to Admin'}
                </Button>
              ) : (
                <Button type="link" onClick={() => navigate('/my/cycles')} icon={<SwapOutlined />}>
                  {isMobile ? 'Personal' : 'Switch to personal reviews'}
                </Button>
              )}
            </div>
          )}

          <Dropdown.Button
            size="small"
            type="primary"
            menu={{ items, onClick: onMenuClick }}
          >
            <a href="/#/settings">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {profile && profile?.profile?.profilePictureUrl ? (
                  <Avatar size={24} src={profile?.profile?.profilePictureUrl} />
                ) : (
                  <UserOutlined />
                )}
                &nbsp;
                <span className={styles.name}>
                  {profile && profile.profile && profile.profile.firstName
                    ? profile.profile.firstName
                    : profile?.email}
                </span>
              </div>
            </a>
          </Dropdown.Button>
        </div>
      </div>
      <EditWorkspaceInfoModal
        isOpen={isEditWorkspaceInfoModalOpen}
        onClose={() => setIsEditWorkspaceInfoModalOpen(false)}
      />
    </div>
  );
};

export default Header;
